@use '@/styles/tokens' as *;

.picker {
  width: 100%;

  &:hover:not(:global(.ant-picker-disabled)) {
    box-shadow: var(--shadow-field-hover);
  }

  :global(.ant-picker-input) > input::placeholder {
    color: var(--overlay-20);
  }
}

.popup {
  :global(.ant-picker-panel-container) {
    border-radius: 14px;
    box-shadow: var(--shadow-overlay);
  }

  :global(.ant-picker-cell-inner) {
    border-radius: 8px;
    font-family: $font-family-base;
  }

  :global(.ant-picker-cell-selected .ant-picker-cell-inner) {
    background: $color-neutral-950;
    color: $color-neutral-50;
  }

  :global(.ant-picker-cell-in-range .ant-picker-cell-inner) {
    background: $color-neutral-100;
  }

  // The day grid shows the viewed month only: leading/trailing days from the
  // adjacent months keep their slot (so the weekday columns hold) but are
  // blank and unclickable. `visibility` also hides the range band's
  // pseudo-elements on those cells.
  :global(.ant-picker-date-panel .ant-picker-cell:not(.ant-picker-cell-in-view)) {
    visibility: hidden;
    pointer-events: none;
  }

  // antd always renders six week rows; a month spanning five leaves a whole
  // row of hidden cells as dead space above the footer, so drop it.
  :global(.ant-picker-date-panel tbody tr:not(:has(.ant-picker-cell-in-view))) {
    display: none;
  }

  // Tighter footer so the Today link sits closer to the grid.
  :global(.ant-picker-footer) {
    line-height: 32px;
  }
}
